<!--
  功能：功能描述 确认弹窗
  作者：chen
  时间：2020年08月27日 09:44:45
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class='confirm-dialog-container' v-show="isShow">
    <div class="dialog">
      <img class="close" src="@static/images/close_tc@3x.png" @click.stop="close" v-show="!hideCloseBtn" />
      <div class="title">
        {{title}}
      </div>
      <div class="content" v-show="message">
        {{message}}
      </div>
      <div class="footer" :class="{'low-margin': message}">
        <div class="btn cancel" @click.stop="cancel" v-show="cancelCallback">{{leftTxt}}</div>
        <div class="btn confirm" :class="{'no-margin': !cancelCallback}" @click.stop="onConfirm">{{rightTxt}}</div>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  model: {
    prop: 'isShow',
    event: 'onEmitShowState'
  },
  props: ['isShow', 'title', 'message', 'submitCallback', 'cancelCallback', 'hideCloseBtn'],
  data () {
    // 这里存放数据
    return {
      leftTxt: '取消',
      rightTxt: '确认'
    }
  },
  // 方法集合
  methods: {
    alert (title, message, submitCallback) {
      this.show(title, message, '', '', submitCallback, null, true)
    },
    confirm (title, message, submitCallback, cancelCallback) {
      this.show(title, message,'', '', submitCallback, cancelCallback, false)
    },
    confirmFollowBtnName(title, message, leftTxt, rightTxt, submitCallback, cancelCallback) {
      this.show(title, message, leftTxt, rightTxt, submitCallback, cancelCallback, false)
    },
    show (title, message, leftTxt, rightTxt, submitCallback, cancelCallback, hideCloseBtn) {
      this.title = title
      this.message = message
      this.submitCallback = submitCallback
      this.cancelCallback = cancelCallback
      this.hideCloseBtn = hideCloseBtn
      if (this.utils.isEmpty(leftTxt)) {
        leftTxt = '取消'
      }
      if (this.utils.isEmpty(rightTxt)) {
        rightTxt = '确认'
      }
      this.leftTxt = leftTxt
      this.rightTxt = rightTxt
      this.isShow = true
    },
    close () {
      this.isShow = false
      this.$emit('onEmitShowState', false)
    },
    cancel () {
      this.cancelCallback && this.cancelCallback()
      this.close()

    },
    onConfirm () {
      this.submitCallback && this.submitCallback()
      this.close()

    }
  },
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

.confirm-dialog-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .dialog {
    background: rgba(255, 255, 255, 1);
    border-radius: 0.08rem;
    margin: 0 0.84rem;
    width: 5.2rem;
    position: relative;
    padding: 0.33rem 0.59rem;
    padding-top: 0.55rem;

    .close {
      position: absolute;
      top: 0.24rem;
      right: 0.22rem;
      width: 0.22rem;
      height: 0.22rem;
    }

    .title {
      font-size: 0.28rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.4rem;
      color: #333333;
      text-align: left;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .content {
      font-size: 0.26rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.37rem;
      color: #868888;
      text-align: left;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.25rem;
    }
    .footer {
      margin-top: 0.8rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &.low-margin {
        margin-top: 0.55rem;
      }

      .btn {
        background: rgba(236, 244, 244, 0.7);
        border-radius: 0.08rem;
        font-size: 0.28rem;
        font-family: MicrosoftYaHei;
        color: rgba(134, 136, 136, 1);
        line-height: 0.37rem;
        padding: 0.18rem 0;
        width: 1.71rem;

        &.cancel {
          margin-right: 0.28rem;
        }

        &.confirm {
          margin-left: 0.28rem;
          background: rgba(53, 194, 190, 1);
          color: rgba(255, 255, 255, 1);
        }
        &.no-margin {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/plugins/dialog/confirmDialog.vue